import React from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { lazyPage } from '../lazyPage';

const SoilTestReports = lazyPage(() => import(/* webpackChunkName: "m-programs" */ '../../pages/SoilTestReports'));
const SingleSoilTestReport = lazyPage(() => import(/* webpackChunkName: "m-programs" */ '../../pages/SingleSoilTestReport'));
const ViewProgram = lazyPage(() => import(/* webpackChunkName: "m-programs" */ '../../pages/ViewProgram'));
const SingleProgram = lazyPage(() => import(/* webpackChunkName: "m-programs" */ '../../pages/SingleProgram'));
const AddProgram = lazyPage(() => import(/* webpackChunkName: "m-programs" */ '../../pages/AddProgram'));
const ProgramMembers = lazyPage(() => import(/* webpackChunkName: "m-programs" */ '../../pages/ProgramMembers'));
const ProgramActivity = lazyPage(() => import(/* webpackChunkName: "m-programs" */ '../../pages/ProgramActivity'));

/**
 * Programs module manifests.
 *
 * CROSSED KEYS FIXED (2026-07-17): historically `programs_360_mgmt` gated Soil and
 * `soil_reports_360_mgmt` gated Programs — inverted. It was left inverted in wave 3
 * because flipping it would have re-mapped EXISTING production grants. That blocker
 * is now gone: RBAC_MODEL adopts a FRESH SEED of the role/feature catalogue (no
 * legacy role reconciliation), so the seed defines these keys correctly and the FE
 * mapping is now the un-crossed, semantically-correct one:
 *   programs_360_mgmt  → Program Management → /view-program
 *   soil_reports_360_mgmt → Soil Management → /soil-test-report
 * The RBAC fixtures (rbacFixtures.js) already name them this way. Flagged for the
 * seed script so backend feature docs match.
 */
const programsManifests = [
    {
        id: 'programs',
        featureName: 'programs_360_mgmt',
        permission: 'view',
        routes: [
            { path: '/view-program', element: <ViewProgram /> },
            { path: '/view-program/:id', element: <SingleProgram /> },
            { path: '/add-program', element: <AddProgram /> },
            { path: '/program-view-members/:id', element: <ProgramMembers /> },
            { path: '/view-activity/:id', element: <ProgramActivity /> },
        ],
        sidebarItems: [{ text: 'Program Management', icon: <ListAltIcon />, link: '/view-program' }],
    },
    {
        id: 'soil-tests',
        featureName: 'soil_reports_360_mgmt',
        permission: 'view',
        routes: [
            { path: '/soil-test-report', element: <SoilTestReports /> },
            { path: '/soil-test-report/:id', element: <SingleSoilTestReport /> },
        ],
        sidebarItems: [{ text: 'Soil Management', icon: <DescriptionIcon />, link: '/soil-test-report' }],
    },
];

export default programsManifests;
